import React, { Component } from "react";
import DownloadResults from "./DownloadResults";
class PdfDetectText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rawText: [],
      rawJson: [],
      formsPair: '',
      tablesPair: '',
      summaryPair: '',
      itemsPair: '',
      sectionElements: {},
    };
  }

  componentDidMount() {
    this.processPDFDetectText(this.props.data);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.processPDFDetectText(this.props.data);
    }
  }

  processPDFDetectText(data) {
    let parsedData = [];
    if (typeof data === "string") {
      try {
        parsedData = JSON.parse(data);
      } catch (err) {
        console.error("Failed to parse data:", err);
        parsedData = [];
      }
    } else if (Array.isArray(data)) {
      parsedData = data;
    }

    this.setState({ rawJson: parsedData });

    let response = parsedData;

    const sectionElements = {
      forms: (
        <div className="no-analysis">
          <div>FORM Analysis is Not Enabled</div>
          <div>If PDF Document contains a FORM : Enable Checkbox and Re-Upload Document</div>
        </div>
      ),
      tables: (
        <div className="no-analysis">
          <div>TABLE Analysis is Not Enabled</div>
          <div>If PDF Document contains a TABLE : Enable Checkbox and Re-Upload Document</div>
        </div>
      ),
      receipt: (
        <div className="no-analysis">
          <div>Receipt Analysis is Not Enabled</div>
          <div>If Image contains a Receipt : Enable Checkbox and Re-Upload Image</div>
        </div>
      ),
    };

    if (!response || response.length === 0) {
      // No text case
      this.setState({
        rawText: ["No text was found"],
        sectionElements,
      });
    } else {
      // Prepare rawText like your jQuery loop
      let rawText = [];

      response.forEach((page, pageIndex) => {
        page.forEach((block, i) => {
          if (block.BlockType === "LINE") {
            rawText.push(
              `${block.Text} (Confidence: ${block.Confidence.toFixed(2)}%)`
            );
          }
        });
      });

      this.setState({
        rawText,
        sectionElements,
      });
    }
  }

  render() {
    const { rawText, sectionElements } = this.state;
    const { type } = this.props;

    return (
      <>
        {type === "text" && (
          <div id="raw-text">
            {rawText.length > 0 ? (
              rawText.map((line, i) => (
                <div key={i} className="text inline-text">
                  {line}
                </div>
              ))
            ) : (
              <div className="no-analysis">
                <p>No text was found</p>
              </div>
            )}
          </div>
        )}
        {type === "form" && <div id="forms">{sectionElements.forms}</div>}
        {type === "table" && <div id="tables">{sectionElements.tables}</div>}
        {type === "receipt" && <div id="receipt">{sectionElements.receipt}</div>}
        <DownloadResults
            rawText={this.state.rawText}
            rawJson={this.state.rawJson}
            forms={this.state.formsPair}
            tables={this.state.tablesPair}
            items={this.state.itemsPair}
            summary={this.state.summaryPair}
        />
      </>
    );
  }
}

export default PdfDetectText;